import React, { useEffect, useState } from "react";

import { withRouter } from 'react-router-dom';
import withShowToast from '../../../hocs/with_show_toast.js';
import withCurrentUser from '../../../hocs/with_current_user.js.jsx';
import { compose } from 'redux';

import I18n from "../../../base/i18n.js.jsx";
import PersonalInfoFields from "../../../base/user_fields/personal_info_fields.js";

import PageContainer from "./components/page_container.js";
import Form from "./components/form.js";
import FormWrapper from "./components/form_wrapper.js";
import NavBlock from "./components/nav_block.js";
import BackButtonBlock from "./components/back_button_block.js";
import SubmitButton from "./components/submit_button.js";
import Title from "./components/title.js";
import LoadingIndicator from "./components/loading_indicator.js";

import CurrentUserUseCase from "../../../use_cases/users/current_user/current_user_use_case.js.jsx";
import UpdateCurrentUserUseCase from "../../../use_cases/users/current_user/update_current_user_use_case.js.jsx";

const ProfilePersonalInfoPage = (props) => {
  const { showSuccessMessage, showServerErrorIfNeed } = props;

  const [loading, setLoading] = useState(true);
  const [personalInfo, setPersonalInfo] = useState({});
  const [errorData, setErrorData] = useState(undefined);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    CurrentUserUseCase.execute()
    .then(result => {
      const { data: { user: { personalInfo } } } = result;

      if(!personalInfo.address) {
        personalInfo.address = {};
      }
      setPersonalInfo(personalInfo);
      setLoading(false);
    })
    .catch((result) => {
      setLoading(false);
      showServerErrorIfNeed(result);
    });
  }, [])

  const onChange = (personalInfo) => {
    setPersonalInfo(personalInfo);
  }

  const onSubmit = () => {
    setErrorData(undefined);
    setSubmitting(true);

    UpdateCurrentUserUseCase.execute({personalInfo: personalInfo})
    .then(result => {
      const { data: { user: { personalInfo } } } = result;
      setPersonalInfo(personalInfo);
      setSubmitting(false);
      showSuccessMessage(I18n.t("shared.toast.successfully_saved"));
    })
    .catch(result => {
      const { errorData: { personalInfo } } = result;
      setErrorData(personalInfo);
      setSubmitting(false);
      showServerErrorIfNeed(result);
    })
  }

  return (
    <PageContainer>
      <Title />
      <NavBlock needReplace = { true } />
      <FormWrapper>
        <BackButtonBlock />
        { loading && <LoadingIndicator /> }
        { !loading &&  
          <Form onSubmit = { onSubmit } >
            <PersonalInfoFields item = { personalInfo }
                                errorData = { errorData } 
                                onChange = { onChange } />
            <SubmitButton disabled = { submitting || loading } />
          </Form>               
        }
      </FormWrapper>   
    </PageContainer>
  );
};

export default compose(withRouter, withCurrentUser, withShowToast)(ProfilePersonalInfoPage);
